export const REACT_QUERY_CONFIG = {
    queries: {
        refetchOnWindowFocus: false,
        retry: 1,
    },
};
